<template>
  <div>
    <div class="card">
      <div class="card-header py-2">
        <Spinner v-if="loading" margin_right="10px" height="20px" />
        <b-form-checkbox v-else class="display-inline marginright5" v-model="checkedAllDpoz"></b-form-checkbox>
        <span @click="checkedAllDpoz = !checkedAllDpoz">Dojazdy pożarowe</span>
        <div style="float: right;">
          <img @click="expanded = !expanded" style="height: 13px; cursor: pointer;" :src="expanded ? icons.chevronUp : icons.chevronDown" />
        </div>
      </div>
      <div class="card-body" v-if="expanded">
        <b-form-checkbox class="display-inline marginright5" v-model="active"></b-form-checkbox>
        <span @click="active = !active">Active</span>
        <b-form-checkbox class="display-inline marginright5" v-model="inactive"></b-form-checkbox>
        <span @click="inactive = !inactive">Inactive</span>
      </div>
    </div>  
  </div>
</template>

<script lang="ts">
import BaseComponent from './Base.vue';
import { EventBus } from '@/ts/EventBus';
import { AlertStatus, DownloadStatus } from '@/ts/types';
import { defineComponent } from "vue";

export default defineComponent({
    extends: BaseComponent,
    data() {
        const checkedAllDpoz: boolean = false;

        return {
            checkedAllDpoz,
            loading: false,
            expanded: false,
            active: true,
            inactive: false
        };
    },
    created() {
      EventBus.$on('downloadExternalData', () => this.downloadDpoz());
      EventBus.$on('toggleDpoz', () => {
        if (this.$options.result) {
          this.checkedAllDpoz = !this.checkedAllDpoz;
        }
      });
      EventBus.$on('selectedAreaChanged', (newArea: string, oldArea: string) => this.onSelectedAreaChanged(newArea, oldArea));
    },
    methods: {

      isPointInSelectedArea(lat: number | string, lon: number | string) {
        // @ts-ignore
        const areaKey = window.selectedArea;
        if (!areaKey) return true;
        // @ts-ignore
        const area = window.areas[areaKey];
        if (!area || !area[0] || !area[1]) return true;
        const minLat = Math.min(area[0][0], area[1][0]);
        const maxLat = Math.max(area[0][0], area[1][0]);
        const minLon = Math.min(area[0][1], area[1][1]);
        const maxLon = Math.max(area[0][1], area[1][1]);
        const plat = Number(lat);
        const plon = Number(lon);
        if (Number.isNaN(plat) || Number.isNaN(plon)) return false;
        return (plat >= minLat && plat <= maxLat && plon >= minLon && plon <= maxLon);
      },

      isPathInSelectedArea(path: any[]) {
        if (!path || !path.length) return false;
        const walk = (p: any): boolean => {
          if (Array.isArray(p)) {
            if (p.length >= 2 && (typeof p[0] === 'number' || typeof p[0] === 'string') && (typeof p[1] === 'number' || typeof p[1] === 'string')) {
              return this.isPointInSelectedArea(p[0], p[1]);
            } else {
              for (const sub of p) {
                if (walk(sub)) return true;
              }
            }
          } else if (p && typeof p === 'object') {
            const lat = p.lat ?? p.latitude ?? p[0];
            const lon = p.lon ?? p.lng ?? p.longitude ?? p[1];
            if (lat !== undefined && lon !== undefined && this.isPointInSelectedArea(lat, lon)) return true;
          }
          return false;
        }
        return walk(path);
      },

      normalizePath(path: any[]) {
        const points: any[] = [];
        if (!path) return points;
        const walk = (p: any) => {
          if (Array.isArray(p)) {
            if (p.length >= 2 && (typeof p[0] === 'number' || typeof p[0] === 'string') && (typeof p[1] === 'number' || typeof p[1] === 'string')) {
              points.push([Number(p[0]), Number(p[1])]);
            } else {
              for (const sub of p) walk(sub);
            }
          } else if (p && typeof p === 'object') {
            const lat = p.lat ?? p.latitude ?? p[0];
            const lon = p.lon ?? p.lng ?? p.longitude ?? p[1];
            if (lat !== undefined && lon !== undefined) points.push([Number(lat), Number(lon)]);
          }
        };
        walk(path);
        return points;
      },

      onSelectedAreaChanged(newArea: string, oldArea: string) {
        if (this.$options.cycleways) {
          for (const segment of this.$options.cycleways) {
            try { segment.removeFrom(window.mainmap); } catch (e) {}
          }
        }
        if (this.$options.result) {
          this.processDpoz();
        }
      },
        downloadDpoz() {
            this.loading = true;
            const endPoint = window.apiHost + 'api/stringfield/dpoz/';
            this.downloadUrlWithCache(endPoint, 'dpoz', 'dpoz.txt', null, true).then((response) => {
              this.$options.result = response[1].results;
              if (response[0] == DownloadStatus.cache_fresh) {
                this.createAlert(AlertStatus.success, this.$t('toursLoaded', [response[1].results.length]).toString(), 2000);
              }
              if (response[0] == DownloadStatus.api_fresh) {
                this.createAlert(AlertStatus.success, this.$t('toursDownloaded', [response[1].results.length]).toString(), 2000);
              }
              if (response[0] == DownloadStatus.cache_last) {
                this.createAlert(AlertStatus.warning, this.$t('toursLoaded', [response[1].results.length]).toString(), 2000);
              }
            }).catch((error) => {
              this.createAlert(AlertStatus.danger, this.$t('toursError').toString(), 2000);
            }).finally(() => {
              this.loading = false;
            });
        },
        processDpoz() {
            const tours: any[] = [];
            for (const responseItem of this.$options.result) {
              const pathPoints = this.normalizePath(responseItem['paths']);
              if (!pathPoints || !pathPoints.length) continue;
              // only include segments that have at least one point inside selected area
              if (!this.isPathInSelectedArea(responseItem['paths'])) {
                continue;
              }
              const cycleway = new L.Polyline(pathPoints, {
                color: 'red',
                weight: 3,
                opacity: 1,
                smoothFactor: 1,
              });

              const fieldsOrder = ['objectid','kod_ob','szer','nr_inw','nr_ppoz','a_year','lenght','is_active'];
              let popupHtml = '';
              for (const f of fieldsOrder) {
                if (f in responseItem) {
                  popupHtml += '<div><strong>' + f + '</strong>: ' + (responseItem[f] ?? '') + '</div>';
                }
              }
              cycleway.bindPopup(popupHtml);

              cycleway.on('mouseover', () => {
                cycleway.setStyle({'color': 'yellow'});
                cycleway.bringToFront();
              });
              cycleway.on('mouseout', () => {
                cycleway.setStyle({'color': 'red'});
              });

              cycleway.on('click', () => {
                try { cycleway.openPopup(); } catch (e) {}
              });

              cycleway.is_active = responseItem.is_active;
              tours.push(cycleway);
            }
            this.$options.cycleways = tours;
            this.onCheckedAllDpozChanged();
        },
        onCheckedAllDpozChanged() {
            if (this.$options.cycleways) {
              for(const segment of this.$options.cycleways) {
                if (this.checkedAllDpoz) {
                  if (segment.is_active) {
                    if (this.active) {
                      segment.addTo(window.mainmap);
                    } else {
                      segment.removeFrom(window.mainmap);
                    }
                  } else {
                    if (this.inactive) {
                      segment.addTo(window.mainmap);
                    } else {
                      segment.removeFrom(window.mainmap);
                    }
                  }
                } else {
                  segment.removeFrom(window.mainmap);
                }
              }
            } else {
              this.processDpoz();
            }
        }
    },
    watch: {
        "checkedAllDpoz": [{
            handler: "onCheckedAllDpozChanged"
        }],
        "active": [{
            handler: "onCheckedAllDpozChanged"
        }],
        "inactive": [{
            handler: "onCheckedAllDpozChanged"
        }]
    }
})


</script>
